import { gql } from "@apollo/client"
export const GET_COMPANY_SUBSCRIPTIONS = gql`
query GetCompanySubscriptions($companyId:UUID!, $query:String, $first:Int, $after:String){
  companySubscriptions(companyId:$companyId, query:$query, first:$first, after:$after) {
  totalCount  
  pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges{
      cursor
      node {
        id
        startDate
        endDate
        status
        subscription {
          id
          name
          description
        }
      }
    }
  }
}`;